const getMainImage = ({ images, imagesConfig }) => {
  if (!imagesConfig) {
    return images[0];
  }

  return images[imagesConfig[0] - 1] || images[0];
};

export default getMainImage;
